import React from 'react';
import styles from './checklist.module.css';

const Checklist = ({ isAfterJan1st2026 }) => {
    if (!isAfterJan1st2026) {
        // Pre-January 1st, 2026 content (current content)
        return (
            <div className={styles.checklist}>
                <h1 className={styles.mainTitle}>O QUE FAZER AGORA:</h1>
                <div className={styles.titleDash}></div>
                <h2 className={styles.subtitle}>Checklist da Reforma Tributária</h2>
                <h3 className={styles.description}>O que sua empresa precisa fazer agora para não ser pega de surpresa:</h3>
                <h3 className={styles.steps}>Passos essenciais:</h3>

                <div className={styles.checklistItems}>
                    <div className={styles.item}>
                        <a target="_placeholder" rel="noopener noreferrer" href="https://espacolegislacao.totvs.com/protheus-reforma-tributaria/" className={styles.itemLink}>
                            <span className={styles.itemText}>Avalie semanalmente as atualizações <strong>legislativas.</strong></span>
                            <span className={styles.saibaMais}>Saiba Mais</span>
                        </a>
                    </div>
                    <div className={styles.item}>
                        <a target="_placeholder" rel="noopener noreferrer" href="https://tdn.totvs.com/pages/viewpage.action?pageId=995199956" className={styles.itemLink}>
                            <span className={styles.itemText}>Avalie semanalmente as atualizações <strong>sistêmicas.</strong></span>
                            <span className={styles.saibaMais}>Saiba Mais</span>
                        </a>
                    </div>
                    <div className={styles.item}>
                        <a target="_placeholder" rel="noopener noreferrer" href="https://tdn.totvs.com/pages/viewpage.action?pageId=960010301" className={styles.itemLink}>
                            <span className={styles.itemText}>Configure corretamente os parâmetros de CBS, IBS e IS.</span>
                            <span className={styles.saibaMais}>Saiba Mais</span>
                        </a>
                    </div>
                    <div className={styles.item}>
                        <a target="_placeholder" rel="noopener noreferrer" href="https://tdn.totvs.com/pages/viewpage.action?pageId=962623217" className={styles.itemLink}>
                            <span className={styles.itemText}>Atualize as tabelas de Classificação Tributária no Configurador de Tributos.</span>
                            <span className={styles.saibaMais}>Saiba Mais</span>
                        </a>
                    </div>
                    <div className={styles.item}>
                        <a target="_placeholder" rel="noopener noreferrer" href="https://tdn.totvs.com/pages/viewpage.action?pageId=995199956" className={styles.itemLink}>
                            <span className={styles.itemText}>Garanta que o envio e recebimento de NFes estejam atualizados e funcionando.</span>
                            <span className={styles.saibaMais}>Saiba Mais</span>
                        </a>
                    </div>
                    <div className={styles.item}>
                        <a target="_placeholder" rel="noopener noreferrer" href="https://tdn.totvs.com/pages/viewpage.action?pageId=966220651" className={styles.itemLink}>
                            <span className={styles.itemText}>Siga os mesmos processos para os documentos de entrada.</span>
                            <span className={styles.saibaMais}>Saiba Mais</span>
                        </a>
                    </div>
                </div>
            </div>
        );
    }

    // Post-January 1st, 2026 content (new content)
    return (
        <div className={styles.checklist}>
            <h1 className={styles.mainTitle}>EM QUE ESTÁGIO A SUA EMPRESA ESTÁ NA REFORMA?</h1>
            <div className={styles.titleDash}></div>
            <h2 className={styles.subtitle}>Checklist da Reforma Tributária</h2>
            <h3 className={styles.description}>Empresas que não estruturaram seus ajustes em 2025, precisam se ajustar para atenderem às exigências do novo modelo tributário!</h3>
            <h3 className={styles.steps}>Passos essenciais:</h3>

            <div className={styles.checklistItems}>
                <div className={styles.item}>
                    <a target="_placeholder" rel="noopener noreferrer" href="https://tdn.totvs.com/pages/releaseview.action?pageId=587835160" className={styles.itemLink}>
                        <span className={styles.itemText}>Avalie semanalmente as atualizações <strong>sistêmicas.</strong></span>
                        <span className={styles.saibaMais}>Saiba Mais</span>
                    </a>
                </div>
                <div className={styles.item}>
                    <a target="_placeholder" rel="noopener noreferrer" href="https://tdn.totvs.com/pages/viewpage.action?pageId=960010301" className={styles.itemLink}>
                        <span className={styles.itemText}>Configure corretamente os parâmetros de CBS, IBS e IS.</span>
                        <span className={styles.saibaMais}>Saiba Mais</span>
                    </a>
                </div>
                <div className={styles.item}>
                    <a target="_placeholder" rel="noopener noreferrer" href="https://tdn.totvs.com/pages/viewpage.action?pageId=962623217" className={styles.itemLink}>
                        <span className={styles.itemText}>Atualize as tabelas de Classificação Tributária no Configurador de Tributos.</span>
                        <span className={styles.saibaMais}>Saiba Mais</span>
                    </a>
                </div>
                <div className={styles.item}>
                    <a target="_placeholder" rel="noopener noreferrer" href="https://tdn.totvs.com/pages/viewpage.action?pageId=995199956" className={styles.itemLink}>
                        <span className={styles.itemText}>Garanta que o envio e recebimento de NFes estejam atualizados e funcionando.</span>
                        <span className={styles.saibaMais}>Saiba Mais</span>
                    </a>
                </div>
            </div>

            <h3 className={`${styles.description} ${styles.descriptionSpaced}`}>Para empresas já adequadas, o desafio passa a ser acompanhar a evolução regulatória e sistêmica do novo modelo tributário.</h3>

            <div className={styles.checklistItems}>
                <div className={styles.item}>
                    <a target="_placeholder" rel="noopener noreferrer" href="https://espacolegislacao.totvs.com/protheus-reforma-tributaria/" className={styles.itemLink}>
                        <span className={styles.itemText}>Avalie semanalmente as atualizações <strong>legislativas.</strong></span>
                        <span className={styles.saibaMais}>Saiba Mais</span>
                    </a>
                </div>
                <div className={styles.item}>
                    <a target="_placeholder" rel="noopener noreferrer" href="https://tdn.totvs.com/pages/viewpage.action?pageId=1010253803" className={styles.itemLink}>
                        <span className={styles.itemText}>Conheça as funcionalidades de Notas Fiscais de Débito e de Crédito no Compras</span>
                        <span className={styles.saibaMais}>Saiba Mais</span>
                    </a>
                </div>
                <div className={styles.item}>
                    <a target="_placeholder" rel="noopener noreferrer" href="https://tdn.totvs.com/pages/viewpage.action?pageId=1013620273" className={styles.itemLink}>
                        <span className={styles.itemText}>Conheça as funcionalidades de Notas Fiscais de Débito e de Crédito no Faturamento</span>
                        <span className={styles.saibaMais}>Saiba Mais</span>
                    </a>
                </div>
                <div className={styles.item}>
                    <a target="_placeholder" rel="noopener noreferrer" href="https://tdn.totvs.com/display/TAF/Monitor+de+Eventos+-+TAF+-+P12" className={styles.itemLink}>
                        <span className={styles.itemText}>Conheça a funcionalidade de Monitor de Eventos dos Documentos Fiscais Eletrônicos</span>
                        <span className={styles.saibaMais}>Saiba Mais</span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Checklist;
